export default "__VITE_ASSET__95bf0958__"